export const parseRegExp = (strExp: string): RegExp => {
  const r = /^\/(.+)\/(.*)$/.exec(strExp);
  if (r && r[1] && typeof r[2] === "string") {
    return new RegExp(r[1], r[2]);
  }
  return new RegExp(strExp);
};
